import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { BackupRecord } from '../types/backupList.types';

export const backupListService = {
  async getBackups(companyId: string): Promise<BackupRecord[]> {
    await enforceSettingsPermission('settings.backup.view', { companyId });
    const { data, error } = await supabase
      .from('backup_records')
      .select('*')
      .eq('company_id', companyId)
      .order('created_at', { ascending: false });
      
    if (error) throw error;
    
    return data.map((d: any) => ({
      id: d.id,
      name: d.name,
      size: d.size,
      type: d.type,
      status: d.status,
      createdAt: d.created_at
    }));
  },

  async createBackup(companyId: string, userId: string): Promise<void> {
    await enforceSettingsPermission('settings.backup.create');
    
    // Simulate backup creation delay
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    const { error } = await supabase
      .from('backup_records')
      .insert({
        company_id: companyId,
        name: `Manual Backup - ${new Date().toLocaleDateString('vi-VN')} ${new Date().toLocaleTimeString('vi-VN')}`,
        size: Math.floor(Math.random() * (1500 - 500) + 500) + ' MB',
        type: 'manual',
        status: 'completed',
        created_by: userId
      });
      
    if (error) throw error;
  },
  
  async deleteBackup(id: string): Promise<void> {
    const { error } = await supabase
      .from('backup_records')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};
